import React, { type HTMLAttributes, type ReactElement } from "react";
import { SitesThemeListItem } from "@/components";
import { ThemeLegend } from "@/types";

interface SitesThemeListProps extends HTMLAttributes<HTMLUListElement> {
  themes: ThemeLegend[];
}

function SitesThemeList({
  themes,
}: Readonly<SitesThemeListProps>): ReactElement {
  return (
    <ul className="list-none flex flex-col gap-1">
      {themes.map((theme): ReactElement => {
        return (
          <SitesThemeListItem
            count={theme.count}
            key={theme.type}
            label={theme.label}
            type={theme.type}
          />
        );
      })}
    </ul>
  );
}

export { SitesThemeList, type SitesThemeListProps };
